import ReCAPTCHA, { ReCAPTCHAProps } from "react-google-recaptcha";

export type RecaptchaProps = Omit<ReCAPTCHAProps, "sitekey">;

export const Recaptcha = ({ onChange, className, ...props }: RecaptchaProps) => {
  const sitekey = import.meta.env.VITE_RIDEMINDER_GOOGLE_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

  return <ReCAPTCHA sitekey={sitekey} onChange={onChange} className={className} {...props} />;
};
